export const PAGE_TITLE_ALL_PRODUCTS = 'All Products';
export const PAGE_TITLE_BRAND = 'Brands';
export const NUMBER_OF_FEATURED_IMAGES = 12;
